import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import PanelContext from '../../sidebar/panel/panelContext';
import ArticleActions from '../../articleActions/articleActions';
import PreviewButton from '../../articleActions/actionTypes/previewButton';
import ViewAtPublisherAnchor from '../../articleActions/actionTypes/viewAtPublisherAnchor';
import { DoiArticleEventsPropTypes } from '../../../utils/trackers/createArticleEvents';

export default function DoiArticleListItemActions({
  doi,
  openPreview,
  viewAtPublisherEventData,
}) {
  const { getId, didOpenPanel } = useContext(PanelContext);
  const idSuffix = getId();
  const id = `preview-button-doi-${encodeURIComponent(doi)}-${idSuffix}`;
  return (
    <ArticleActions>
      <PreviewButton
        id={id}
        onClick={openPreview}
        hasHighlight={didOpenPanel(id)}
      />
      <ViewAtPublisherAnchor
        id={`view-at-publisher-button-doi-${encodeURIComponent(doi)}-${idSuffix}`}
        doi={doi}
        viewAtPublisherEventData={viewAtPublisherEventData}
      />
    </ArticleActions>
  );
}

DoiArticleListItemActions.propTypes = {
  doi: PropTypes.string.isRequired,
  openPreview: PropTypes.func.isRequired,
  viewAtPublisherEventData: DoiArticleEventsPropTypes.viewAtPublisher,
};

DoiArticleListItemActions.defaultProps = {
  viewAtPublisherEventData: {},
};
